import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    Typography,
    IconButton,
    InputAdornment,
    makeStyles
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

import config from '../../config/config.json';

const host = config.production.hostBackoffice;

const useStyles = makeStyles((theme) => ({
    formContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '20px auto',
        width: 300,
    },
    textField: {
        marginBottom: theme.spacing(2),
        width: '100%',
    },
    button: {
        color: "white",
        backgroundColor: "orange",
        width: '100%',
        marginTop: theme.spacing(2),
    },
}));

const FormPasswordInput = ({ hash }) => {
    const classes = useStyles();
    const [verificationStatus, setVerificationStatus] = useState('');
    const [showResetForm, setShowResetForm] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [resetStatus, setResetStatus] = useState('');

    const handleShowPasswordClick = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        const verifyHash = async () => {
            try {
                let data = JSON.stringify({ "hash": hash });

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: host + '/checkout/',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: data
                };

                const response = await axios.request(config);

                setVerificationStatus(response.data.status);

                if (response.data.status === "ok") {
                    setShowResetForm(true);
                } else {
                    setShowResetForm(false);
                }
            } catch (error) {
                console.error('Errore durante la verifica dell\'hash:', error);
                setVerificationStatus('error');
            }
        };

        verifyHash();
    }, [hash]);

    const handleResetPassword = async () => {
        if (password !== confirmPassword) {
            setResetStatus('Le password non coincidono');
            return;
        }

        try {
            let data = JSON.stringify({ "hash": hash, "password": password });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: host + '/doit/',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: data
            };

            const response = await axios.request(config);

            setResetStatus(response.data.status);

            if (response.data.status === "ok") {
                window.location.href = host;
            }
        } catch (error) {
            console.error('Errore durante il reset della password:', error);
            setResetStatus('error');
        }
    };

    return (
        <div>
            {showResetForm && (
                <form className={classes.formContainer}>
                    <TextField
                        label="Nuova password"
                        type={showPassword ? 'text' : 'password'}
                        variant="outlined"
                        className={classes.textField}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleShowPasswordClick}>
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Conferma nuova password"
                        type={showPassword ? 'text' : 'password'}
                        variant="outlined"
                        className={classes.textField}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleShowPasswordClick}>
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={handleResetPassword}
                    >
                        Reset Password
                    </Button>
                    {resetStatus && (
                        <Typography variant="body1" color="error">
                            {resetStatus === 'ok' ? 'Password reset successful' : resetStatus}
                        </Typography>
                    )}
                </form>
            )}
            {!showResetForm && (
                <Typography variant="body1" color="error">
                    {verificationStatus === 'error' ? 'Accesso negato' : 'Form loading'}
                </Typography>
            )}
        </div>
    );
};

export default FormPasswordInput;
